/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Dashboard controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetDashboardTodoStatsResponse, GetDashboardTimesheetStatsResponse, GetDashboardInvoicingStatsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class DashboardService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getDashboardTodoStats(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetDashboardTodoStatsResponse>;
    getDashboardTodoStats(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetDashboardTodoStatsResponse>>;
    getDashboardTodoStats(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetDashboardTodoStatsResponse>>;
    getDashboardTodoStats(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Dashboard/todo-stats`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getDashboardTimesheetStats(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetDashboardTimesheetStatsResponse>;
    getDashboardTimesheetStats(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetDashboardTimesheetStatsResponse>>;
    getDashboardTimesheetStats(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetDashboardTimesheetStatsResponse>>;
    getDashboardTimesheetStats(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Dashboard/timesheet-stats`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getDashboardInvoicingStats(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetDashboardInvoicingStatsResponse>;
    getDashboardInvoicingStats(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetDashboardInvoicingStatsResponse>>;
    getDashboardInvoicingStats(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetDashboardInvoicingStatsResponse>>;
    getDashboardInvoicingStats(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Dashboard/invoicing-stats`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
